import { League } from '@/types/user';
import { assetsBaseUrl } from '@/shared/constants';

export const getLeagueLogo = (league: Pick<League, 'name' | 'logoFilename'> | null | undefined): string => {
  if (!league?.name || !league.logoFilename) return '';
  return `${assetsBaseUrl}/leagues/${league.name.toLowerCase()}/${league.logoFilename}`;
};
